export default "__VITE_ASSET__3up38Q1e__"